export default __webpack_public_path__ + "static/media/Snd_LowerVSlidedown.0f88ce55.mp3";